export const AdminDashboardPage = () => {
    return (
        <div className="h-full w-full items-center justify-center flex">
            <p>Admin Dashboard</p>
        </div>
    );
};
